exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big-number[data-v-bd8ed702]{display:inline-block}", ""]);

// exports
